<template>
  <div class="w-full px-2">
    <h4 class="text-white text-[16px] font-[500]">{{ title }}</h4>
    <div
      class="flex items-center h-[52px] justify-between mt-4 text-sm gap-2 bg-[#2C3235] rounded-[10px]"
    >
      <span class="px-4 flex-1 text-[13px] break-all">{{ domain }}</span>
      <span
        @click="copyText(text)"
        class="px-3 bg-[#64F765] mr-2 h-[42px] leading-[42px] w-[77px] text-[15px] text-center rounded-lg text-[#151A1F] font-[600]"
      >
        Copiar
      </span>
    </div>
  </div>
</template>

<script setup lang="tsx">
import { useGetDomain } from "@/hooks/useGetDomain";
import { copyText } from "@/utils";
import appConfig from "@/config";
const text = ref<string>("");
const props = defineProps({
  title: {
    // 默认标题
    type: String,
    default: "Link de Convite",
  },
  noActivity: {
    // 是否不包含活动id
    type: Boolean,
    default: false,
  },
  textType: {
    // 文本类型   treasurebox 宝箱
    type: String,
    default: "domain",
  },
});
const { domain } = useGetDomain(props.noActivity);
//配置复制文本
const getText = () => {
  const hostName = handleHost(appConfig.siteName);
  switch (props.textType) {
    //默认
    case "domain":
      text.value = domain.value;
      break;
    //宝箱
    case "treasurebox":
      text.value = `Olá, estou jogando no ${hostName}, onde há uma chance muito alta de ganhar, e você pode ganhar dinheiro de verdade! ${domain.value}`;
      break;
  }
};

const handleHost = (host: string) => {
  return host?.startsWith("www") ? host?.slice(4) : host;
};
// 监听domain
watch(
  () => domain.value,
  (newVal) => {
    getText();
  }
);
</script>
